module.exports = __webpack_public_path__ + "static/media/audience.4251ba1e.svg";